export default __webpack_public_path__ + "static/media/check-mark.4e6e6091.svg";